export default __webpack_public_path__ + "static/media/undraw_profile_pic.27e27200.png";